import EmployeeCard from "../components/employeeCard";

export default function ContactUs() {
    return (
        <section className="home-div">
            <h2>Address</h2>
            <iframe title="M Smith Accounting Location Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1441.6442033053681!2d-79.40392425801329!3d43.72533521605124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b32dd647aaaaf%3A0x22208ce94ddcb032!2s3080%20Yonge%20St%2C%20Toronto%2C%20ON%20M4N%203N1!5e0!3m2!1sen!2sca!4v1767877206052!5m2!1sen!2sca" width="100%" height="450" style={{"border": "0"}} loading="lazy"></iframe>
            <p>3080 Yonge Street, Suite 5040 - Toronto, ON M4N 3N1</p>
            <h2 style={{paddingTop: '100px'}}>Contact Us</h2>
            <p>For general inquiries please contact below:</p>
            <div className="employee-grid">
                <EmployeeCard
                    name=""
                    role=""
                    education=""
                    phone="416-483-1115"
                    extension=""
                    fax="416-483-9450"
                    email="info@msmithaccounting.ca"
                />
            </div>
            <hr/>
            <h3>Staff</h3>
            <div className="employee-grid">
                <EmployeeCard
                    name="Michael Smith"
                    role=""
                    education="CPA, CGA, HBAcc"
                    phone="416-483-1115"
                    extension="224"
                    fax=""
                    email="mike@msmithaccounting.ca"
                />

                <EmployeeCard
                    name="Elizabeth Smith"
                    role=""
                    education=""
                    phone="416-483-1115"
                    extension="221"
                    fax=""
                    email="lizz@msmithaccounting.ca"
                />

                <EmployeeCard
                    name="Chris Yang"
                    role=""
                    education=""
                    phone="416-483-1115"
                    extension="227"
                    fax=""
                    email="chris@msmithaccounting.ca"
                />

                <EmployeeCard
                    name="Zbigniew Bielecki"
                    role=""
                    education=""
                    phone="416-483-1115"
                    extension="227"
                    fax=""
                    email="zbigniew@msmithaccounting.ca"
                />

                <EmployeeCard
                    name="Orlando Icban"
                    role=""
                    education=""
                    phone="416-483-1115"
                    extension="226"
                    fax=""
                    email="orlando@msmithaccounting.ca"
                />
            </div>
        </section>
    );
}